import React from "react";

import chrome from "common/assets/images/chrome-min.png";
import edge from "common/assets/images/edge-min.png";
import firefox from "common/assets/images/firefox-min.png";
import safariLogo from "common/assets/images/safariLogo-min.png";

import Modal from "features/common/modals/containers/Modal";

import styles from "./DeviceWarningModal.module.scss";

type Props = {
  topMessage: string;
  imgURL?: Array<string> | string;
  bottomMessage?: string;
};

export default function DeviceWarningModal({
  topMessage,
  imgURL = [chrome, edge, firefox, safariLogo],
  bottomMessage
}: Props) {
  if (typeof imgURL === "string") imgURL = [imgURL];
  return (
    <Modal open>
      <div className={styles.wrapper}>
        <div className={styles.topMessage}>{topMessage}</div>
        <div className={styles.imageWrapper}>
          {imgURL
            ? imgURL.map((url, i) => (
                <img key={i} className={styles.image} src={url} alt="" />
              ))
            : null}
        </div>
        {bottomMessage && (
          <p className={styles.bottomMessage}>{bottomMessage}</p>
        )}
      </div>
    </Modal>
  );
}
